"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactFinalForm = require("react-final-form");

var _ramda = require("ramda");

var _reactFinalFormArrays = require("react-final-form-arrays");

var _reactI18next = require("react-i18next");

var _qs = _interopRequireDefault(require("qs"));

var _Input = _interopRequireDefault(require("./formComponents/Input"));

var _Checkbox = _interopRequireWildcard(require("./formComponents/Checkbox"));

var _PersonalDataAgreement = _interopRequireDefault(require("./formComponents/PersonalDataAgreement"));

var _Select = _interopRequireWildcard(require("./formComponents/Select"));

var _DictionarySelect = _interopRequireDefault(require("./formComponents/DictionarySelect"));

var _TreeSelect = _interopRequireDefault(require("./formComponents/TreeSelect"));

var _PhoneInput = _interopRequireDefault(require("./formComponents/PhoneInput"));

var _DateSelect = _interopRequireDefault(require("./formComponents/DateSelect"));

var _File = _interopRequireDefault(require("./formComponents/File"));

var _Radio = _interopRequireDefault(require("./formComponents/Radio"));

var _Money = _interopRequireDefault(require("./formComponents/Money"));

var _dictionaries = _interopRequireWildcard(require("../constants/dictionaries"));

var _validation = require("../utils/validation");

var _translations = require("../constants/translations");

var _withFieldWrapper = _interopRequireDefault(require("./hocs/withFieldWrapper"));

var _LinkedFieldWrapper = _interopRequireDefault(require("./hocs/LinkedFieldWrapper"));

var _questions = require("../utils/questions");

var _field = require("../utils/field");

var _i18n = require("../utils/i18n");

var _form = require("../constants/form");

var _HtmlOpdForm = require("./formComponents/HtmlOpdForm");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = {
  "formWrapper": "index__formWrapper",
  "formBtn": "index__formBtn",
  "formBtnCancel": "index__formBtnCancel",
  "formLink": "index__formLink",
  "withoutOpd": "index__withoutOpd",
  "formLabel": "index__formLabel",
  "formLabelRequired": "index__formLabelRequired",
  "formLabelOptional": "index__formLabelOptional",
  "formInput": "index__formInput",
  "formTextarea": "index__formTextarea",
  "formSection": "index__formSection",
  "formSectionRow": "index__formSectionRow",
  "formSectionBtn": "index__formSectionBtn",
  "error": "index__error",
  "compositeError": "index__compositeError",
  "fileInput": "index__fileInput",
  "fileControls": "index__fileControls",
  "formDateSelect": "index__formDateSelect",
  "formMoneySelect": "index__formMoneySelect",
  "amountField": "index__amountField",
  "currencyField": "index__currencyField",
  "imagePreview": "index__imagePreview",
  "dangerBtn": "index__dangerBtn",
  "dangerBtnDisabled": "index__dangerBtnDisabled",
  "fileList": "index__fileList",
  "fileItem": "index__fileItem",
  "downloadButton": "index__downloadButton",
  "downloadButtonDisabled": "index__downloadButtonDisabled",
  "fileButtonGroup": "index__fileButtonGroup",
  "timeIndicator": "index__timeIndicator",
  "modalButtonGroup": "index__modalButtonGroup"
};

var CompositeError = function CompositeError(_ref) {
  var meta = _ref.meta;
  return (0, _ramda.is)(String, meta.error) && meta.error && meta.submitFailed ? /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.compositeError
  }, meta.error) : null;
};

var getFieldComponent = function getFieldComponent(field, components) {
  var type = field.type,
      _field$settings = field.settings,
      settings = _field$settings === void 0 ? {} : _field$settings;
  var DEFAULT_FIELDS = {
    text: _Input["default"],
    email: _Input["default"],
    personalDataAgreement: _PersonalDataAgreement["default"],
    dictionary: (0, _ramda.prop)('checkboxes', settings) ? (0, _ramda.prop)('multiple', settings) ? _Checkbox["default"] : _Radio["default"] : _Select["default"],
    phone: _PhoneInput["default"],
    "boolean": _Checkbox.Boolean,
    choice: (0, _ramda.prop)('checkboxes', settings) ? (0, _ramda.prop)('multiple', settings) ? _Checkbox["default"] : _Radio["default"] : _Select["default"],
    country: _Select.LocationSelect,
    region: _Select.LocationSelect,
    city: _Select.LocationSelect,
    date: _DateSelect["default"],
    file: _File["default"],
    money: _Money["default"],
    company_dictionary: (0, _ramda.prop)('tree', settings) ? _TreeSelect["default"] : _DictionarySelect["default"]
  };
  var fields = (0, _ramda.mapObjIndexed)(function (component, key) {
    return components[key] ? (0, _withFieldWrapper["default"])(components[key]) : component;
  }, DEFAULT_FIELDS);
  return fields[type];
};

var defaultFormRender = function defaultFormRender(_ref2) {
  var fields = _ref2.fields,
      renderField = _ref2.renderField;
  return fields.map(renderField);
};

var Fields = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Fields, _Component);

  var _super = _createSuper(Fields);

  function Fields(_props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Fields);
    _this = _super.call(this, _props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getDictionary", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(type, dataPath, urlParams) {
        var optionsPaths,
            _this$props,
            apiUrl,
            dictionaryOptions,
            response,
            responseData,
            data,
            _args = arguments;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                optionsPaths = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};

                if (!(type && !(0, _ramda.contains)(type, _this.dictionaryTypes))) {
                  _context.next = 34;
                  break;
                }

                _this$props = _this.props, apiUrl = _this$props.apiUrl, dictionaryOptions = _this$props.dictionaryOptions;
                _context.prev = 3;
                urlParams = _qs["default"].parse(urlParams || {}, {
                  ignoreQueryPrefix: true
                });
                urlParams = (0, _ramda.assocPath)(['filter', 'company'], _this.props.company, urlParams);
                _context.next = 8;
                return fetch("".concat(apiUrl || '', "/api/").concat(_dictionaries.GEO_DICTIONARIES[type] ? type : "dictionary/".concat(type || ''), "?").concat(_qs["default"].stringify(urlParams) || ''), _objectSpread(_objectSpread({}, dictionaryOptions), {}, {
                  method: 'GET',
                  headers: {
                    'accept-language': _translations.RU
                  }
                }));

              case 8:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 11;
                  break;
                }

                throw new Error();

              case 11:
                if (!dataPath) {
                  _context.next = 20;
                  break;
                }

                _context.t1 = _ramda.prop;
                _context.t2 = dataPath;
                _context.next = 16;
                return response.json();

              case 16:
                _context.t3 = _context.sent;
                _context.t0 = (0, _context.t1)(_context.t2, _context.t3);
                _context.next = 23;
                break;

              case 20:
                _context.next = 22;
                return response.json();

              case 22:
                _context.t0 = _context.sent;

              case 23:
                responseData = _context.t0;
                data = Array.isArray(responseData) ? responseData : [responseData];

                if (_this.props.excludeDictionary[type]) {
                  data = (0, _ramda.filter)(function (item) {
                    return !(0, _ramda.includes)(item.id, _this.props.excludeDictionary[type]);
                  }, data);
                }

                if (_this.props.renameDictionary[type]) {
                  data = data.map(function (item) {
                    return _this.props.renameDictionary[type][item.id] ? _objectSpread(_objectSpread({}, item), {}, {
                      name: _this.props.renameDictionary[type][item.id]
                    }) : item;
                  });
                }

                _this.dictionaryTypes.push(type);

                _this.props.setFormState(function (prev) {
                  return {
                    dictionaries: _objectSpread(_objectSpread({}, prev.dictionaries), {}, (0, _defineProperty2["default"])({}, type, data.map(function (item) {
                      return {
                        label: (0, _ramda.propOr)((0, _ramda.propOr)('', 'name', item), optionsPaths.labelPath, item),
                        value: (0, _ramda.propOr)(item.id, optionsPaths.valuePath, item),
                        internalId: item.internalId,
                        country: item.country,
                        region: item.region,
                        translations: item.translations
                      };
                    }))),
                    errors: _objectSpread(_objectSpread({}, prev.errors), {}, (0, _defineProperty2["default"])({}, type, false))
                  };
                });

                _context.next = 34;
                break;

              case 31:
                _context.prev = 31;
                _context.t4 = _context["catch"](3);

                _this.props.setFormState(function (prev) {
                  return {
                    dictionaries: _objectSpread({}, prev.dictionaries),
                    errors: _objectSpread(_objectSpread({}, prev.errors), {}, (0, _defineProperty2["default"])({}, type, true))
                  };
                });

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 31]]);
      }));

      return function (_x, _x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getDictionaryType", function (field) {
      var settings = field.settings,
          type = field.type;
      var dictionary = (0, _ramda.path)(['dictionary'], settings);

      if (dictionary) {
        return dictionary;
      } else {
        return _dictionaries["default"][type] || _dictionaries.GEO_DICTIONARIES[type];
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getOptions", function (field) {
      var language = _this.props.language;
      var options = _this.props.dictionaries[(0, _ramda.path)(['settings', 'dictionary'], field)] || _this.props.dictionaries[_dictionaries["default"][field.type]] || _this.props.dictionaries[_dictionaries.GEO_DICTIONARIES[field.type]] || (0, _ramda.pathOr)([], ['settings', 'choices'], field).map(function (_ref4) {
        var value = _ref4.value,
            id = _ref4.id,
            translations = _ref4.translations;
        return {
          label: value,
          value: id,
          translations: translations && translations.choices
        };
      });

      if ((0, _ramda.isEmpty)(options)) {
        return [];
      }

      if (language === _translations.RU) {
        return options;
      } else {
        return options.map(function (option) {
          return _objectSpread(_objectSpread({}, option), {}, {
            label: (0, _i18n.translateOptionLabel)(option, language)
          });
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangeQuestion", function (field) {
      return function (value, form) {
        var batch = form.batch,
            change = form.change,
            getState = form.getState;
        var fields = _this.props.fields;
        var fieldType = field.fieldType,
            name = field.field;
        var isLinked = (0, _questions.isLinkedQuestion)(field);
        var formValues = (0, _ramda.prop)('values', getState());

        if (isLinked && formValues[name] !== value) {
          var geoQuestions = (0, _questions.findChildGeoQuestionsNames)(fields, fieldType, formValues);
          !(0, _ramda.isEmpty)(geoQuestions) && batch(function () {
            return geoQuestions.forEach(function (fieldName) {
              change(fieldName, undefined);
            });
          });
        }
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (_, field) {
      var values = _this.props.formProps.form.getState().values;

      var html = (0, _ramda.path)(['personalDataAgreement', 'htmlContent'], values);

      if ((0, _ramda.includes)(field.field, _this.props.updateOpdValuesOn) && html) {
        var opdValues = _this.props.getOpdValues ? _this.props.getOpdValues({
          values: values
        }) : {};
        var container = document.createElement('div');
        container.innerHTML = html;
        var el = container.querySelector('.opd-html-form');
        var form = document.createElement('div');
        form.append(el);
        var inputs = form.querySelectorAll('input');
        (0, _ramda.forEach)(function (input) {
          var value = (0, _ramda.path)([input.name], opdValues);

          if (value) {
            input.setAttribute('value', (0, _ramda.trim)("".concat(value || '')));
          }
        }, inputs);

        _this.props.formProps.form.change('personalDataAgreement.htmlContent', (0, _HtmlOpdForm.getHtml)(form.innerHTML));
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderField", function (field, name, form) {
      var _this$props2 = _this.props,
          opd = _this$props2.opd,
          opdSettings = _this$props2.opdSettings,
          getFileUrl = _this$props2.getFileUrl,
          postFileUrl = _this$props2.postFileUrl,
          apiUrl = _this$props2.apiUrl,
          company = _this$props2.company,
          language = _this$props2.language,
          languageOrigin = _this$props2.languageOrigin,
          pdaLanguage = _this$props2.pdaLanguage,
          components = _this$props2.components,
          htmlOpd = _this$props2.htmlOpd,
          htmlOpdStyles = _this$props2.htmlOpdStyles,
          getOpdValues = _this$props2.getOpdValues,
          serverErrors = _this$props2.serverErrors,
          fields = _this$props2.fields,
          allowFileExtensions = _this$props2.allowFileExtensions,
          renderOpdLabel = _this$props2.renderOpdLabel,
          fieldsWithoutValidation = _this$props2.fieldsWithoutValidation,
          errors = _this$props2.errors,
          changeFieldValidation = _this$props2.changeFieldValidation,
          selectHeight = _this$props2.selectHeight,
          selectLineHeight = _this$props2.selectLineHeight,
          updateOpdValues = _this$props2.updateOpdValues;
      var fieldName = name || field.field;
      var isLinked = (0, _field.isLinkedField)(field);

      var validateField = function validateField(value, form) {
        return (0, _validation.validate)(value, form, field, fieldsWithoutValidation, _this.props, {
          htmlOpd: htmlOpd,
          allowFileExtensions: allowFileExtensions
        });
      };

      var renderLinkedField = function renderLinkedField() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, (0, _extends2["default"])({
          name: fieldName,
          component: getFieldComponent(field, components) || function () {
            return null;
          },
          fieldType: field.type,
          options: _this.getOptions(field),
          opd: opd,
          opdSettings: opdSettings,
          company: company,
          language: language,
          pdaLanguage: pdaLanguage,
          languageOrigin: languageOrigin,
          validate: validateField,
          getDictionary: _this.getDictionary,
          dictionaryType: _this.getDictionaryType(field),
          getFileUrl: getFileUrl,
          postFileUrl: postFileUrl,
          apiUrl: apiUrl
        }, field, {
          label: language ? (0, _ramda.pathOr)(field.label, ['translations', 'label', language], field) : field.label,
          extra: (0, _ramda.path)(['extra'], field),
          errors: errors,
          htmlOpd: htmlOpd,
          htmlOpdStyles: htmlOpdStyles,
          getOpdValues: getOpdValues,
          form: form,
          initialRequired: field.required,
          fieldsWithoutValidation: fieldsWithoutValidation,
          changeFieldValidation: changeFieldValidation,
          serverErrors: serverErrors,
          fields: fields,
          allowFileExtensions: allowFileExtensions,
          renderOpdLabel: renderOpdLabel,
          selectHeight: selectHeight,
          selectLineHeight: selectLineHeight,
          updateOpdValues: updateOpdValues,
          onChangeQuestion: _this.onChangeQuestion(field),
          onChange: function onChange(value) {
            return _this.onChange(value, field);
          }
        }, props));
      };

      return isLinked ? /*#__PURE__*/_react["default"].createElement(_LinkedFieldWrapper["default"], {
        field: field,
        form: form,
        fieldName: fieldName
      }, renderLinkedField) : /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, (0, _extends2["default"])({
        name: fieldName,
        component: getFieldComponent(field, components) || function () {
          return null;
        },
        fieldType: field.type,
        options: _this.getOptions(field),
        opd: opd,
        opdSettings: opdSettings,
        validate: validateField,
        getDictionary: _this.getDictionary,
        dictionaryType: _this.getDictionaryType(field),
        getFileUrl: getFileUrl,
        postFileUrl: postFileUrl,
        apiUrl: apiUrl
      }, field, {
        label: language ? (0, _ramda.pathOr)(field.label, ['translations', 'label', language], field) : field.label,
        extra: (0, _ramda.path)(['extra'], field),
        errors: errors,
        htmlOpd: htmlOpd,
        htmlOpdStyles: htmlOpdStyles,
        getOpdValues: getOpdValues,
        form: form,
        initialRequired: field.required,
        fieldsWithoutValidation: fieldsWithoutValidation,
        changeFieldValidation: changeFieldValidation,
        serverErrors: serverErrors,
        fields: fields,
        allowFileExtensions: allowFileExtensions,
        renderOpdLabel: renderOpdLabel,
        selectHeight: selectHeight,
        selectLineHeight: selectLineHeight,
        language: language,
        pdaLanguage: pdaLanguage,
        languageOrigin: languageOrigin,
        onChangeQuestion: _this.onChangeQuestion(field),
        onChange: function onChange(value) {
          return _this.onChange(value, field);
        }
      }));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderCompositeRemoveButton", function (field, index) {
      if (field.required) {
        return index !== 0;
      } else {
        return true;
      }
    });
    _this.dictionaryTypes = [];
    return _this;
  }

  (0, _createClass2["default"])(Fields, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          fields = _this$props3.fields,
          language = _this$props3.language,
          formProps = _this$props3.formProps,
          formRender = _this$props3.formRender,
          t = _this$props3.t,
          disabled = _this$props3.disabled;
      var FormRender = formRender || defaultFormRender;
      return /*#__PURE__*/_react["default"].createElement(FormRender, (0, _extends2["default"])({}, formProps, {
        fields: fields,
        renderField: function renderField(field) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: field.field
          }, field.type === 'composite' ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, (0, _ramda.includes)((0, _ramda.path)(['settings', 'showLabel'], field), [true, undefined]) ? /*#__PURE__*/_react["default"].createElement("h2", null, language ? (0, _ramda.pathOr)(field.label, ['translations', 'label', language], field) : field.label) : null, (0, _ramda.path)(['settings', 'multiple'], field) ? /*#__PURE__*/_react["default"].createElement(_reactFinalFormArrays.FieldArray, {
            name: field.field,
            validate: field.required ? _validation.compositeValidator : undefined,
            initialValue: _form.fieldArrayInitialValues
          }, function (fieldProps) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              className: styles.formSection
            }, /*#__PURE__*/_react["default"].createElement(CompositeError, {
              meta: (0, _ramda.prop)('meta', fieldProps)
            }), fieldProps.fields.map(function (name, index) {
              return /*#__PURE__*/_react["default"].createElement("div", {
                key: name,
                className: styles.formSectionRow
              }, (0, _ramda.pathOr)([], ['settings', 'questions'], field).map(function (question) {
                return /*#__PURE__*/_react["default"].createElement("div", {
                  key: "".concat(name, "-").concat(question.field)
                }, _this2.renderField(question, "".concat(name, ".").concat(question.field), formProps.form));
              }), _this2.renderCompositeRemoveButton(field, index) && /*#__PURE__*/_react["default"].createElement("button", {
                disabled: disabled,
                className: styles.formSectionBtn,
                type: "button",
                onClick: function onClick() {
                  return fieldProps.fields.remove(index);
                }
              }, t('remove')));
            }), /*#__PURE__*/_react["default"].createElement("button", {
              disabled: disabled,
              className: styles.formSectionBtn,
              type: "button",
              onClick: function onClick() {
                return fieldProps.fields.push({});
              }
            }, t('addQuestionBlock')));
          }) : (0, _ramda.pathOr)([], ['settings', 'questions'], field).map(function (question) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: "".concat(field.field, "-").concat(question.field)
            }, _this2.renderField(question, "".concat(field.field, ".").concat(question.field), formProps.form));
          })) : _this2.renderField(field, null, formProps.form));
        }
      }));
    }
  }]);
  return Fields;
}(_react.Component);

(0, _defineProperty2["default"])(Fields, "defaultProps", {
  fields: [],
  dictionaryOptions: {},
  components: {},
  language: _translations.RU,
  disabled: false,
  excludeDictionary: {},
  renameDictionary: {}
});

var _default = (0, _reactI18next.withTranslation)()(Fields);

exports["default"] = _default;